export default "__VITE_ASSET__DQZIpa4K__"